import { Typography } from '@recruit-robin/robin-theme/web-components';
import { IconCallback } from '@recruit-robin/robin-theme/web-icons';
import { Fragment } from 'react';

import { isLastArrayItem } from '@/shared/lib/array';
import { Badge } from '../badge/Badge';
import { Bullet } from '../bullet/Bullet';
import { useStyles } from './Section.styles';

const SectionTitle = ({
  title,
  icon: Icon,
  hasVerified = false,
}: {
  title: string;
  icon: IconCallback;
  hasVerified?: boolean;
}) => {
  const classes = useStyles();

  return (
    <div css={classes.sectionTitle}>
      <Icon size={16} />
      <Typography variant={(v) => v.supporting.label} color={(c) => c.neutral.variant[70]} inline>
        {title}
      </Typography>
      {hasVerified && <Badge.Verified>Checked</Badge.Verified>}
    </div>
  );
};

const SectionList = ({
  items,
  direction = 'vertical',
}: {
  items: { label: string; badge: string; isVerified?: boolean }[];
  direction?: 'horizontal' | 'vertical';
}) => {
  const classes = useStyles();

  return (
    <div css={[classes.sectionContent, direction === 'horizontal' && classes.horizontalSectionContent]}>
      {items.map((item, index) => (
        <Fragment key={index}>
          <div css={classes.item}>
            <Typography variant={(v) => v.supporting.label} color={(c) => c.neutral.variant[70]} inline>
              {item.label}
            </Typography>
            <Badge.Info isVerified={item.isVerified}>{item.badge}</Badge.Info>
          </div>
          {direction === 'horizontal' && !isLastArrayItem(items, index) && <Bullet />}
        </Fragment>
      ))}
    </div>
  );
};

export const Section = ({ title, body }: { title: React.ReactNode; body: React.ReactNode }) => {
  const classes = useStyles();

  return (
    <div css={classes.section}>
      <div css={classes.title}>{title}</div>
      {body}
    </div>
  );
};

Section.Title = SectionTitle;
Section.List = SectionList;
